<div class="project-frequencie-main-container" [formGroup]="form">
    <div class="frequencie-container">
        <span class="project-frequencie-main-container-title">{{'project_team_frequency_title' | translate}}</span>
        <div *ngFor="let frequency of projectFrequencies" 
            class="frequencie" 
            [ngClass]="{'active': frequency.uuid === form.get('frequency')?.value,
                        'preview-disabled': frequency.uuid !== form.get('frequency')?.value && previewMode,
                        'preview-active': frequency.uuid === form.get('frequency')?.value && previewMode
            }"
            (click)="setFrequency(frequency.uuid)">
            <p-radioButton *ngIf="!previewMode" 
                [value]="frequency.uuid" 
                [label]="(frequency.name | titlecase)"
                formControlName="frequency"></p-radioButton>
            <div *ngIf="previewMode" class="preview-mode-container">
                <div class="img-container">
                    <img src="../../../assets/svg/calendar-clock.svg">
                </div>
                <span>{{frequency.name | titlecase}}</span>
            </div>
            <div *ngIf="frequency.slug === '14_days'" class="recomended-container">
                <span>{{'project_team_frequency_recomanded' | translate}}</span>
            </div>
        </div>
    </div>
    <div class="frequencie-container start-date">
        <span class="project-frequencie-main-container-title">{{'project_team_checkin_start_date_title' | translate}}</span>
        <div *ngFor="let date of kickOffDateList, let index = index" 
            class="frequencie"
            [ngClass]="{'active': date.value === form.get('checkinStartDate')?.value,
                        'preview-disabled': date.value !== form.get('checkinStartDate')?.value && previewMode,
                        'preview-active': date.value === form.get('checkinStartDate')?.value && previewMode
            }"
            (click)="setKickOffDateRadioBtn(date.value)">
            <p-radioButton *ngIf="!previewMode"
                formControlName="checkinStartDate"
                [value]="date.value" 
                [label]="date.label"></p-radioButton>
            <div *ngIf="index === 1 && !previewMode" class="calendar-wrapper">
                <img class="calendar-icon" (click)="startDateCalendar?.toggle()" src="../../../../../assets/svg/m_info_icon_calendar.svg">
                <p-calendar
                    #startDateCalendar
                    id="projectStartDate"
                    formControlName="otherCheckinStartDate"
                    [showIcon]="false"
                    dateFormat="d MM y"
                    [showButtonBar]="true"
                    class="date-calendar"
                    (keydown.enter)="$event.preventDefault();$event.stopPropagation()">
                </p-calendar>
            </div>
            <div *ngIf="previewMode" class="preview-mode-container">
                <div class="img-container">
                    <img style="width: 2.3rem; height: 2.3rem;" src="../../../assets/svg/m_info_icon_calendar.svg">
                </div>
                <span>{{date.value | date: 'd MMMM y'}}</span>
            </div>
        </div>
    </div>
</div>